import { useQuery, useQueryClient } from "@tanstack/react-query";
import { createCrudHooks, processResult, STALE_TIME } from "../common/queries";
import api from "../http-common";

export const reportCardApi = {
	...createCrudHooks({
		baseKey: "reportCards",
		basePath: "/reportCards",
		getParams: { include: [{association: 'ratings'}] },
	}),

	useLookup(studentId, termId) {
		const qc = useQueryClient();
		return useQuery({
			queryKey: ["reportCards", studentId, termId],
			queryFn: () => api.get(`/reportCards/lookup/${studentId}/${termId}`, { params: { include: [{association: 'ratings'}] } })
				.then(r => processResult(qc, r)),
			staleTime: STALE_TIME,
		});
	},
};
